import React, { FC } from "react";
import { IconProps } from "../types";

export const Transfer: FC<IconProps> = ({ ...props }) => {
  return (
    <svg
      {...props}
      className={`${props.className}`}
      xmlns="http://www.w3.org/2000/svg"
      width="1080"
      viewBox="0 0 810 810"
      height="1080"
      version="1.0"
    >
      <path fill="#fff" d="M-81-81h972v972H-81z" />
      <path fill="#fff" d="M-81-81h972v972H-81z" />
      <path
        fill="#003e86"
        d="M210.8 580.242q-29.264 0-49.613-20.445c-13.562-13.629-20.347-30.18-20.347-49.652H75.938v-277.79q-.001-12.315 8.769-21.085t21.086-8.77H553.5l180.563 170.176v137.469h-54.52q0 29.208-20.484 49.652t-49.75 20.445q-29.264 0-49.61-20.445-20.348-20.444-20.347-49.652H281.035c0 19.382-6.828 35.914-20.484 49.585q-20.489 20.513-49.75 20.512m270.137-223.27h197.438l-136.298-128.51h-61.14Zm-189.519 0h163.559v-128.51h-163.56Zm-189.52 0h163.559v-128.51h-163.56Zm108.895 199.255q19.291-.001 32.758-13.32 13.47-13.325 13.469-32.618-.001-19.291-13.32-32.758-13.325-13.47-32.618-13.469-19.291.002-32.758 13.32-13.47 13.326-13.469 32.614.002 19.296 13.32 32.762 13.325 13.47 32.618 13.469m398.508 0q19.293-.001 32.761-13.32 13.465-13.325 13.465-32.618c0-12.86-4.437-23.781-13.32-32.758q-13.318-13.47-32.613-13.469-19.294.002-32.762 13.32-13.467 13.326-13.469 32.614 0 19.296 13.324 32.762 13.319 13.47 32.614 13.469m-507.403-72.043h42.254q7.2-18.693 26.125-31.414 18.915-12.721 40.66-12.723c14.497 0 27.723 3.918 39.688 11.75s21.215 18.625 27.746 32.387h264.531c4.641-12.032 13.27-22.391 25.883-31.09q18.92-13.046 40.664-13.047 21.74.002 39.688 12.074 17.941 12.07 27.746 32.063h31.219v-101.25H101.898Zm606.204-101.25H101.898Zm0 0"
      />
    </svg>
  );
};
